import React, { Component } from 'react';
import { Container } from 'semantic-ui-react';
import styles from './MakePaymentHeader.module.scss';

class MakePaymentHeader extends Component {
	render() {
		return (
			<Container>
				<div className={styles.container}>
					<a href='http://www.indianafarmers.com/'>
						<div className={styles.logo}></div>
					</a>
					<ul className={styles.menu}>
						<li>
							<a href='http://www.indianafarmers.com/about-us/contact-us'>Contact Us</a>
						</li>
						<li>
							<a href='http://www.indianafarmers.com/help'>Help</a>
						</li>
						<li>
							<a href='http://www.indianafarmers.com/claim-center'>Report a Claim</a>
						</li>
						<li>
							<a href='http://www.indianafarmers.com/about-us'>About Us</a>
						</li>
						<li className={styles.myAccount}>
							<a href='http://member.indianafarmers.com'>My Account</a>
						</li>
					</ul>
				</div>
			</Container>
		);
	}
}

export default MakePaymentHeader;
